export default class PaginationSetting {
    constructor() {
        this.page = 1;
        this.pageSize = 5;
        this.orderBy = '';
        this.desc = true;
    }
}
